import { render, staticRenderFns } from "./DriverSalesList.vue?vue&type=template&id=ef127b94&"
import script from "./DriverSalesList.vue?vue&type=script&lang=js&"
export * from "./DriverSalesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DriverSalesList.vue"
export default component.exports